import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ContactPage from "../pages/contact/page";
import ThankYou from "../pages/thank-you/page";
import HowItWorksPage from "../pages/how-it-works/page";
import PlansPage from "../pages/plans/page";
import IndustriesPage from "../pages/industries/page";
import WhyUsPage from "../pages/why-us/page";
import ResultsPage from "../pages/results/page";
import FAQPage from "../pages/faq/page";
import AboutPage from "../pages/about/page";
import BlogPage from "../pages/blog/page";
import BlogPostPage from "../pages/blog/post";
import PrivacyPage from "../pages/legal/privacy";
import TermsPage from "../pages/legal/terms";
import DisclaimerPage from "../pages/legal/disclaimer";
import StartLLCPage from "../pages/start-llc/page";

const routes: RouteObject[] = [
  // Default: redirect root to Spanish
  { path: "/", element: <Navigate to="/es" replace /> },

  // English Routes
  { path: "/contact", element: <ContactPage /> },
  { path: "/thank-you", element: <ThankYou /> },
  { path: "/how-it-works", element: <HowItWorksPage /> },
  { path: "/plans", element: <PlansPage /> },
  { path: "/industries", element: <IndustriesPage /> },
  { path: "/why-us", element: <WhyUsPage /> },
  { path: "/results", element: <ResultsPage /> },
  { path: "/faq", element: <FAQPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/blog", element: <BlogPage /> },
  { path: "/blog/:slug", element: <BlogPostPage /> },
  { path: "/start-your-llc", element: <StartLLCPage /> },

  // Legal Pages
  { path: "/privacy-policy", element: <PrivacyPage /> },
  { path: "/terms-of-service", element: <TermsPage /> },
  { path: "/disclaimer", element: <DisclaimerPage /> },

  // Spanish Routes
  { path: "/es", element: <Home /> },
  { path: "/es/como-funciona", element: <HowItWorksPage /> },
  { path: "/es/planes", element: <PlansPage /> },
  { path: "/es/industrias", element: <IndustriesPage /> },
  { path: "/es/por-que-nosotros", element: <WhyUsPage /> },
  { path: "/es/resultados", element: <ResultsPage /> },
  { path: "/es/preguntas-frecuentes", element: <FAQPage /> },
  { path: "/es/sobre-nosotros", element: <AboutPage /> },
  { path: "/es/contacto", element: <ContactPage /> },
  { path: "/es/gracias", element: <ThankYou /> },
  { path: "/es/blog", element: <BlogPage /> },
  { path: "/es/blog/:slug", element: <BlogPostPage /> },
  { path: "/es/inicia-tu-llc", element: <StartLLCPage /> },
  { path: "/es/politica-de-privacidad", element: <PrivacyPage /> },
  { path: "/es/terminos-de-servicio", element: <TermsPage /> },
  { path: "/es/aviso-legal", element: <DisclaimerPage /> },

  { path: "*", element: <NotFound /> },
];

export default routes;
